import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { returnsApi, type Claim } from '../../api/returns';

export function ClaimsDashboardPage() {
  const [claims, setClaims] = useState<Claim[]>([]);

  useEffect(() => {
    void returnsApi.listClaims().then(setClaims);
  }, []);

  async function submitClaim() {
    await returnsApi.createClaim({ type: 'carrier', amount: 500 });
    setClaims(await returnsApi.listClaims());
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/returns" className="text-sm text-slate-600 hover:underline">← Returns hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Claims dashboard</h1>
      <button type="button" onClick={() => void submitClaim()}
        className="mt-4 rounded bg-slate-900 px-4 py-2 text-sm text-white">Submit carrier claim</button>
      <ul className="mt-6 space-y-2 text-sm">
        {claims.map((c) => (
          <li key={c.id} className="rounded border p-3">{c.claim_number} — {c.type} · {c.status}</li>
        ))}
      </ul>
    </div>
  );
}
